import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const EkiTrigger = () => {
  const tileId = useTargetAccumulatorTileId();
  const ekiTrigger = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.ekiTrigger);
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('EkiTrigger') ?? false,
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleEki = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'EkiTrigger changed', isDefined(value) ? String(value) : 'null');

    return checkTargetAccumulatorWithTradeCapture({
      ekiTrigger: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.ekiTrigger">
      <TradeCaptureValidationWrapper validation={validation?.ekiTrigger}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          className={isCustom ? 'text-info' : undefined}
          data-e2e-is-modified={isCustom}
          value={ekiTrigger}
          maxDecimals={9}
          onChange={handleEki}
          size="sm"
          data-e2e="eki-trigger"
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default EkiTrigger;
